'use client';

import { forwardRef, type FunctionComponent } from 'react';
import Link from 'next/link';
import { PolymorphicComponentProps, Button, ButtonProps } from '@mantine/core';

type LinkButtonProps = Omit<
  PolymorphicComponentProps<typeof Link, ButtonProps>,
  'component'
>;

/**
 * LinkButton
 *
 * A Button with Link characteristics.
 * This component allows use of Button with next/link in next16, where changes to
 * Link caused polymorphic errors without 'use client' directives;
 */
const LinkButton: FunctionComponent<LinkButtonProps> = forwardRef<
  HTMLAnchorElement,
  LinkButtonProps
>((props, ref) => <Button component={Link} ref={ref} {...props} />);

LinkButton.displayName = 'LinkButton';

export default LinkButton;
